import { createContext, useContext, type ReactNode } from 'react'

interface AnnouncementVideoContextValue {
  openAnnouncementVideo: (id: string) => void
}

const AnnouncementVideoContext = createContext<AnnouncementVideoContextValue | null>(null)

export function AnnouncementVideoProvider({
  children,
  value,
}: {
  children: ReactNode
  value: AnnouncementVideoContextValue
}) {
  return (
    <AnnouncementVideoContext.Provider value={value}>
      {children}
    </AnnouncementVideoContext.Provider>
  )
}

export function useAnnouncementVideo() {
  const context = useContext(AnnouncementVideoContext)
  if (!context) {
    throw new Error('useAnnouncementVideo must be used within AnnouncementOverlayContainer')
  }
  return context
}
